var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"pss__header"},[_c('div',{staticClass:"pss__header-left"},[_c('brand')],1),_c('div',{staticClass:"pss__header-right"},[_c('user-info'),_c('logout-btn')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }